React = require 'react'

styles = require './attention'

module.exports = (props) ->
  React.createElement("div", {"className": (styles.container)},
    (props.children)
  )
